import React from 'react'
import { createUrl } from '../../../../../Routing/urls'
import { CURRENT_YEAR } from '../../../../../Config/League/league.config'
import {
  PlayerCardStyle,
  PlayerInfoCon,
  PlayerNameYearsCon,
  SecondaryRow,
  PlayerProfileCon,
} from '../styles'
import { PlayerDataGQL } from '../../../../../Api'
import { formatNumberOrdinal, getTeamIc } from '../../../../../Utils'
import {
  getAccoladeCount,
  getPlayerExperience,
} from '../../../../../Utils/Players/playersHelper'
import { colors } from '../../../../../Components/consts'
import { StarFilled } from '../../../../../Components/Icons'
import { Lk } from '../../../../../Components/Links/Lk'
import { Img } from '../../../../../Components/Image/Img'

type PlayerProps = {
  playerInfo: PlayerDataGQL | null
  side: 'left' | 'right'
  showAccolade?: boolean
}

export const PlayerItem: React.FC<React.PropsWithChildren<PlayerProps>> = ({
  playerInfo,
  side,
  showAccolade = false,
}) => {
  const getStatsUrl = () =>
    createUrl('player', {
      firstName: playerInfo?.firstName,
      lastName: playerInfo?.lastName,
      slugName: playerInfo?.slug,
      tab: 'stats',
      year: CURRENT_YEAR,
    })

  const renderAccolade = () => {
    if (!playerInfo) return
    let accoladeCount = getAccoladeCount('All-Star', playerInfo)
    return `${accoladeCount}X`
  }

  const renderExperience = (player: PlayerDataGQL) => {
    let exp = getPlayerExperience(player)
    if (!exp) return
    return `${formatNumberOrdinal(exp)} year`
  }
  return (
    <>
      {playerInfo && (
        <PlayerCardStyle side={side}>
          <Lk link={getStatsUrl()} alt={`${playerInfo.name} Profile`}>
            {side === 'right' && (
              <PlayerProfileCon side={side}>
                <Img src={playerInfo.profileUrl} alt={`${playerInfo.name} Profile`} />
              </PlayerProfileCon>
            )}
            <PlayerInfoCon side={side}>
              {showAccolade && (
                <SecondaryRow side={side}>
                  <StarFilled fill={colors.yellow} width={12} />
                  <div className="accolade">{renderAccolade()}</div>
                </SecondaryRow>
              )}
              <div className="playerTitleContainer">
                {side === 'right' && (
                  <>
                    <h1>{playerInfo?.currentTeam?.jerseyNum ?? 0}</h1>
                    <PlayerNameYearsCon side={side}>
                      <h3>{`${playerInfo.name}`}</h3>
                      <p>{renderExperience(playerInfo)}</p>
                    </PlayerNameYearsCon>
                  </>
                )}
                {side === 'left' && (
                  <>
                    <PlayerNameYearsCon side={side}>
                      <h3>{`${playerInfo.name}`}</h3>
                      <p>{renderExperience(playerInfo)}</p>
                    </PlayerNameYearsCon>
                    <h1>{playerInfo?.currentTeam?.jerseyNum ?? 0}</h1>
                  </>
                )}
              </div>
              <SecondaryRow side={side}>
                {playerInfo?.currentTeam?.fullName && side === 'left' && (
                  <Img
                    src={getTeamIc(playerInfo.currentTeam.fullName)}
                    alt={playerInfo.currentTeam.fullName}
                  />
                )}
                <div className="positionText">
                  <strong>{playerInfo.position}</strong>
                </div>
                {playerInfo?.currentTeam?.fullName && side === 'right' && (
                  <Img
                    src={getTeamIc(playerInfo.currentTeam.fullName)}
                    alt={playerInfo.currentTeam.fullName}
                  />
                )}
              </SecondaryRow>
            </PlayerInfoCon>
            {side === 'left' && (
              <PlayerProfileCon side={side}>
                <Img src={playerInfo.profileUrl} alt={`${playerInfo.name} Profile`} />
              </PlayerProfileCon>
            )}
          </Lk>
        </PlayerCardStyle>
      )}
    </>
  )
}
